module.exports = __webpack_public_path__ + "img/inventoryBill.3bba15b2.png";